import { render } from "./NewNews.vue?vue&type=template&id=ae0239c8&scoped=true"
import script from "./NewNews.vue?vue&type=script&lang=js"
export * from "./NewNews.vue?vue&type=script&lang=js"

import "./NewNews.vue?vue&type=style&index=0&id=ae0239c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae0239c8"]])

export default __exports__